import { Pipe, PipeTransform } from '@angular/core';

// ***** This pipe is for Member shop only ******

@Pipe({
    name: 'filterBy',
    pure: false
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], term, termValue): any {

        if (!items || !Array.isArray(items)) {
            return [];
        }

        return (term && items.length > 0) ? items.filter(item => item[term] == termValue) : items;
    }
}